// import styles
import "./NavCard.css";

// import pacchetti
import React from "react";
import { Link } from "react-router-dom";

export default function HomeCard({ data, isFavorite, onToggleFavorite }) {
  // Determina la classe CSS in base al tipo di card
  const cardClass = data.tipo ? `card-${data.tipo}` : "";
  const Icon = data?.Icon;
  const legacyIcon = data?.icon;

  return (
    <div className="nav-card">
      <Link to={`/${data.action}`} key={data.nome} className={cardClass}>
        {typeof onToggleFavorite === "function" && (
          <button
            type="button"
            className={`favorite-star ${isFavorite ? "active" : ""}`}
            aria-label={
              isFavorite ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"
            }
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onToggleFavorite(data.action);
            }}
          >
            {isFavorite ? "★" : "☆"}
          </button>
        )}
        <h4>
          {Icon ? (
            <Icon size={18} className="nav-card-icon" />
          ) : typeof legacyIcon === "function" ? (
            React.createElement(legacyIcon, {
              size: 18,
              className: "nav-card-icon",
            })
          ) : React.isValidElement(legacyIcon) ? (
            React.cloneElement(legacyIcon, {
              className: ["nav-card-icon", legacyIcon.props?.className]
                .filter(Boolean)
                .join(" "),
            })
          ) : legacyIcon ? (
            <span className="nav-card-icon">{legacyIcon}</span>
          ) : null}
          {data.nome}
          {data.notificationCount > 0 && (
            <span className="nav-card-badge">{data.notificationCount}</span>
          )}
          {data.secondaryNotificationCount > 0 && (
            <span className="nav-card-badge nav-card-badge-green">
              {data.secondaryNotificationCount}
            </span>
          )}
          {data.orangeNotificationCount > 0 && (
            <span className="nav-card-badge nav-card-badge-orange">
              {data.orangeNotificationCount}
            </span>
          )}
        </h4>
        <p>{data.message}</p>
      </Link>
    </div>
  );
}
